<template>
	<v-row class="ma-0 pb-offset">
		<v-col cols="12" class="pa-0">
			<v-card class="flex pa-0 background-2 round-card">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">Importazione fatture ricevute</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-row class="ma-0 pa-4">
					<v-col cols="12" md="6">
						<v-select v-model="settings['import_sectional_purchaseinvoice']" :items="sectionals" item-text="name" item-value="id" outlined dense clearable label="Sezionale fatture di acquisto"></v-select>
					</v-col>
					<v-col cols="12" md="6">
						<v-select v-model="settings['import_sectional_suppliercreditnote']" :items="sectionals" item-text="name" item-value="id" outlined dense clearable label="Sezionale note di credito fornitore"></v-select>
					</v-col>
					<v-col cols="12" md="6">
						<v-select v-model="settings['import_unmatched_lines']" :items="unmatchedModes" outlined dense label="Righe senza prodotto in anagrafica"></v-select>
					</v-col>
					<v-col cols="12" md="6" v-if="settings['import_unmatched_lines'] !== 'create_product'">
						<async-autocomplete v-model="defaultProduct" async-url="async-products" :items="defaultProductItems" label="Prodotto generico" return-object clearable></async-autocomplete>
					</v-col>
					<v-col cols="12" md="6">
						<v-select v-model="settings['import_default_payment_term']" :items="paymentTerms" item-text="text" item-value="value" outlined dense clearable label="Condizione di pagamento di ripiego (XML senza scadenze)"></v-select>
					</v-col>
					<v-col cols="12" md="6">
						<v-checkbox v-model="settings['import_auto_create_supplier']" color="primary" label="Crea automaticamente i fornitori mancanti dai dati dell'XML"></v-checkbox>
					</v-col>
					<v-col cols="12">
						<strong>Mappatura IVA</strong>
						<small class="d-block grey--text mb-2">Ha la precedenza sull'abbinamento automatico per aliquota: serve anche a scegliere il codice quando più codici IVA hanno la stessa aliquota.</small>
						<v-row v-for="(row, i) in vatMapping" :key="i" class="ma-0">
							<v-col cols="3"><v-text-field v-model="row.rate" type="number" step="0.01" outlined dense label="Aliquota"></v-text-field></v-col>
							<v-col cols="3"><v-text-field v-model="row.natura" outlined dense label="Natura (es. N2.2)"></v-text-field></v-col>
							<v-col cols="5"><v-select v-model="row.vat" :items="vatCodes" item-text="text" item-value="value" outlined dense label="Codice IVA"></v-select></v-col>
							<v-col cols="1"><v-btn icon @click="vatMapping.splice(i, 1)"><v-icon>mdi-close</v-icon></v-btn></v-col>
						</v-row>
						<v-btn text color="primary" @click="vatMapping.push({ rate: null, natura: '', vat: null })"><v-icon left>mdi-plus</v-icon>aggiungi mappatura</v-btn>
					</v-col>
				</v-row>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-3" color="primary" @click.native="save()">Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin.js'

	export default {
		name: 'edocument-import-options',
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				model: 'edocument',
				settings: {
					'import_sectional_purchaseinvoice': null,
					'import_sectional_suppliercreditnote': null,
					'import_unmatched_lines': 'default_product',
					'import_default_product_id': null,
					'import_default_payment_term': null,
					'import_auto_create_supplier': true,
					'import_vat_mapping': [],
				},
				defaultProduct: null,
				defaultProductItems: [],
				vatMapping: [],
				sectionals: [],
				paymentTerms: [],
				vatCodes: [],
				unmatchedModes: [
					{ text: 'Usa il prodotto generico', value: 'default_product' },
					{ text: 'Crea un nuovo prodotto (con associazione fornitore)', value: 'create_product' },
				],
			}
		},
		watch: {
			'settings.import_vat_mapping': {
				immediate: true,
				handler(value) {
					// Un valore salvato non piu' JSON valido non deve far esplodere
					// il componente: si ripiega su un mapping vuoto.
					let parsed = []
					try {
						parsed = typeof value === 'string' ? JSON.parse(value || '[]') : (value || [])
					} catch (e) {
						parsed = []
					}
					this.vatMapping = Array.isArray(parsed) ? parsed : []
				}
			},
			'settings.import_default_product_id': {
				immediate: true,
				handler(id) {
					if (!id) {
						this.defaultProduct = null
						return
					}
					if (this.defaultProduct && this.defaultProduct.value === id) {
						return
					}
					this.axios.get('products/' + id + '?lite=1').then(response => {
						this.defaultProduct = { value: id, text: response.data.model.name }
						this.defaultProductItems = [this.defaultProduct]
					}, () => {})
				}
			},
		},
		methods: {
			save() {
				this.settings['import_vat_mapping'] = this.vatMapping
					.filter(r => r.rate !== null && r.rate !== '' && r.vat)
					.map(r => ({ ...r, rate: parseFloat(r.rate) }))
				this.settings['import_default_product_id'] = this.defaultProduct ? this.defaultProduct.value : null
				this.saveSettings()
			},
			loadLists() {
				this.axios.post('sectionals-filters', {
					page: 1,
					per_page: 1000,
					sortBy: [],
					sortDesc: [false],
					advancedFilters: {},
					filter: ''
				}).then(response => {
					this.sectionals = (response.data.data && response.data.data.data) || []
				}, () => {})
				this.axios.get('edocuments-import/vat-codes').then(response => {
					this.vatCodes = (response.data.data || []).map(v => ({ text: v.text, value: v.key }))
				}, () => {})
				this.axios.post('generaltypes-payment_term-filters', { paginate: false }).then(response => {
					this.paymentTerms = (response.data.data && response.data.data.data) || []
				}, () => {})
			},
		},
		created() {
			this.loadLists()
		},
	}
</script>
